'use client'
import JsonLd from '../../components/JsonLd'
import { ContactForm } from '../../components/blocks/contact'
import {
  organizationAreaServedJsonLd,
  organizationPostalAddressJsonLd,
} from '../../lib/site-organization'

export default function ContactPage() {
  const contactJsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'ContactPage',
        '@id': 'https://cloudshuttle.com.au/contact-us/#webpage',
        url: 'https://cloudshuttle.com.au/contact-us',
        name: 'Contact Cloud Shuttle - Get In Touch',
        description:
          'Contact Cloud Shuttle for expert data engineering services. Reach out for consultations, workshops, or project inquiries.',
        isPartOf: {
          '@type': 'WebSite',
          '@id': 'https://cloudshuttle.com.au/#website',
        },
        about: {
          '@type': 'Organization',
          '@id': 'https://cloudshuttle.com.au/#organization',
        },
        mainEntity: {
          '@type': 'Organization',
          '@id': 'https://cloudshuttle.com.au/#organization',
        },
      },
      {
        '@type': 'Organization',
        '@id': 'https://cloudshuttle.com.au/#organization',
        name: 'Cloud Shuttle',
        address: [organizationPostalAddressJsonLd()],
        areaServed: organizationAreaServedJsonLd,
        contactPoint: [
          {
            '@type': 'ContactPoint',
            telephone: '+61-433-825-293',
            contactType: 'customer service',
            areaServed: ['AU', 'NZ'],
            availableLanguage: ['English'],
          },
          {
            '@type': 'ContactPoint',
            email: 'info@cloudshuttle.com.au',
            contactType: 'sales',
            areaServed: ['AU', 'NZ'],
          },
          {
            '@type': 'ContactPoint',
            url: 'https://cloudshuttle.com.au/contact-us',
            contactType: 'sales',
            areaServed: ['AU', 'NZ'],
          },
        ],
      },
    ],
  }

  return (
    <>
      <JsonLd data={contactJsonLd} />
      <ContactForm color="dark" />
    </>
  )
}
